import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AdminisSharedModule } from './../components/shared/adminis-shared.module';
import { AuthorisedComponent } from './authorised/authorised.component';
import { ModalModule } from '../components/modal/modal.module';
import { NavigationComponent } from './../components/header/navigation/navigation.component';
import { UnauthorisedComponent } from 'src/app/layout/unauthorised/unauthorised.component';
import { HeaderComponent } from 'src/app/components/header/header.component';
import { PublicHeaderComponent } from 'src/app/components/header/public-header.component';
import { UtilsModule } from '../utils/utils.module';
import { UserNotificationsComponent } from '../components/header/notifications/user-notifications.component';
import {DateSelectorComponent} from "../components/header/date-selector/date-selector.component";
import {PortfolioSelectorComponent} from "../components/header/portfolio-selector/portfolio-selector.component";
import {ArrowRightEndIconComponent} from "../components/shared/icon/arrow-right-end/arrow-right-end-icon.component";

@NgModule({
  declarations: [
    AuthorisedComponent,
    HeaderComponent,
    PublicHeaderComponent,
    UserNotificationsComponent,
    NavigationComponent,
    UnauthorisedComponent,
    DateSelectorComponent,
    PortfolioSelectorComponent
  ],
    imports: [
        AdminisSharedModule,
        CommonModule,
        RouterModule,
        ModalModule,
        UtilsModule,
        ArrowRightEndIconComponent,
    ],
  exports: [
    HeaderComponent,
    PublicHeaderComponent,
    NavigationComponent,
    ModalModule,
    AuthorisedComponent,
    AdminisSharedModule,
    UnauthorisedComponent,
  ]
})
export class LayoutModule { }
